<template>
    <div>
      <a-card class="card" title="预约登记" :bordered="false">
          <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-row :gutter="48">
                  <a-col :md="5" :sm="24">
                    <a-form-item label="业务类型">
                      <a-select
                        v-model="selectedBizId"
                        :filterOption="filterOption"
                        @change="handleBizChange"
                        placeholder="请选择"
                        >
                        <a-select-option v-for="(item, index) in bizList" :key="index" :value="item.id">{{ item.name }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  
                  <a-col :md="8" :sm="24" v-show="roleId !== config.RoleType.SUPPLIER && selectedBizId == config.BusinessTypeId.purchase">
                    <a-form-item label="供应商">
                      <a-select
                        v-model="corpSupplierId"
                        showSearch
                        :filterOption="filterOption"
                        placeholder="请选择"
                        default-value="">
                        <a-select-option v-for="(item, index) in supplierSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>

                  <a-col :md="8" :sm="24" v-show="roleId !== config.RoleType.BUSINESS && selectedBizId == config.BusinessTypeId.sell">
                    <a-form-item label="客户">
                      <a-select
                        v-model="corpBusinessId"
                        showSearch
                        :filterOption="filterOption"
                        placeholder="请选择"
                        default-value="">
                        <a-select-option v-for="(item, index) in businessSelect" :key="index" :value="item.id">{{ item.name }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>

                  <a-col :md="7" :sm="24">
                      <a-form-item label="物料名称">
                          <a-select
                          v-model="selectMater"
                          labelInValue
                          @change="changeMateriel"
                          :filterOption="filterOption"
                          placeholder="请选择"
                          >
                          <a-select-option v-for="(item, index) in materList" :key="index" :value="item.id">{{item.name}}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>

        
                  <a-col :md="4" :sm="24">
                    <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <!--     <a-button type="dashed" icon="plus" @click="newMember">添加</a-button> -->
                      <a-button type="dashed" icon="plus" @click="clone">复制</a-button>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>
      </a-card>
  
      <!-- table -->
      <a-card>
        <a-table
          :bordered="config.globlaBordered"
          :columns="columns"
          :dataSource="data"
          :pagination="false"
          :loading="memberLoading"
        >

        <template slot="title_materielName">
          <span style="color:red;margin-right:3px;">*</span>
           物料名称
        </template>

        <template slot="title_predictQuantity">
            <span style="color:red;margin-right:3px;">*</span>
             预约数量
        </template>

        <template slot="title_vehicleNo">
            <span style="color:red;margin-right:3px;">*</span>
            车牌号
        </template>
        
        <template slot="title_driverName">
            <span style="color:red;margin-right:3px;">*</span>
            司机姓名
        </template>

        
        <template slot="title_phone">
            <span style="color:red;margin-right:3px;">*</span>
            手机号
        </template>

        
        <template slot="title_appointedDate">
            <span style="color:red;margin-right:3px;">*</span>
            上门日期
        </template>
        
        <template slot="materielName" slot-scope="text, record,index">
            {{ text }}
        </template>

        <template slot="predictQuantity" slot-scope="text, record">
            <a-input-number  
            :min="0"
            style="width: 130px;"
            @change="(value) => changeNumber(value, record.key)" 
            />
          </template> 


          <template slot="vehicleNo" slot-scope="text, record, index">
  <!--           <lable style="color:red;margin-right:3px;">*</lable> -->
            <a-auto-complete
              v-model="vehicleShowList[index]"
              :dataSource="vehicleNoList"
              placeholder=""
              :filterOption="filterOption"
              @blur="(value) => changeVehicleNo(value, record.key, index, true)"
              @change="(value) => changeVehicleNo(value, record.key, index)" 
            />
        </template>

          <template slot="driverName" slot-scope="text, record, index">
   <!--          <lable style="color:red;margin-right:3px;">*</lable> -->
            <a-auto-complete
              v-model="driverShowList[index]"
              :dataSource="driverNameList"
              style="width: 170px"
              placeholder=""
              :filterOption="filterOption"
              @change="(value) => changeDriver(value, record.key, index)" 
            />
          </template>

          <template slot="phone" slot-scope="text, record, index">
           <!--    <lable style="color:red;margin-right:3px;">*</lable> -->
              <a-auto-complete
                v-model="phoneShowList[index]"
                :dataSource="phoneList"
                placeholder=""
                :filterOption="filterOption"
                @change="(value) => changePhone(value, record.key, index)" 
              />
          </template>

          <template slot="appointedDate" slot-scope="text, record,index">
            <!--   <lable style="color:red;margin-right:3px;">*</lable> -->
              <a-date-picker :defaultValue="defaultDate"  v-model="dateShowList[index]" style="width: 80%" placeholder="请选择日期" @change="(dates,dateStr) => changeDate(dates, dateStr, record.key, index)"/>
          </template>

          <template slot="idcard" slot-scope="text, record, index">
            <a-input
              v-model="idcardShowList[index]"
              placeholder=""
              @change="(e) => changeIdcard(e, record.key, index)" 
            />
        </template>

          <template slot="operation" slot-scope="text, record">
              <span>
                <a-popconfirm title="是否要删除此行？" @confirm="remove(record.key)">
                  <a>删除</a>
                </a-popconfirm>
              </span>
          </template>
         
        </a-table>
       <!--  <a-button style="width: 100%; margin-top: 16px; margin-bottom: 8px" type="dashed" icon="plus" @click="newMember">新增成员</a-button> -->
      </a-card>


      <a-card :bordered="false" >
        <a-button type="primary" @click="doSubmit" :loading="loading" style="float: right">提交</a-button>
      </a-card>
    
    </div>
  </template>

  <script>
  import FooterToolBar from '@/components/FooterToolbar'
  import { mixin, mixinDevice } from '@/utils/mixin'
  import { vehicleSamplingFindByVehicleNo,getCorpSupplierList, corpBusinessList } from '@/api/basic'
  import { reservationAdd, baseInfoList } from '@/api/logistics'
  import store from '@/store'
  import Bus from '@/layouts/bus'
  import moment from 'moment'
  import { formatDate } from '@/utils/date.js'
  import { noSpace } from '@/utils/util.js'


  export default {
    name: 'AdvancedForm',
    mixins: [mixin, mixinDevice],
    components: {
      FooterToolBar,
      VNodes: {
        functional: true,
          render: (h, ctx) => ctx.props.vnodes
        }
      },
    data () {
      return {
        form: this.$form.createForm(this),
        materielList:[],
        driverList:[],
        vehicleList:[],
        vehicleNoList:[],
        driverNameList:[],
        phoneList:[],

        selectMaterielId:null,
        selectMaterielName:null,

        driverShowList:[],
        vehicleShowList:[],
        phoneShowList:[],
        idcardShowList:[],
        dateShowList:[],

        loading: false,
        memberLoading: false,

        bizList:this.$store.getters.bizList,
        selectedBizId: null,
        preBizId:null,
        materielData:{},
        materList:[],
        selectMater: {key: '', label: '请选择'},

        supplierSelect:null,
        businessSelect:null,
        roleId:null,
        corpSupplierId:'',
        corpBusinessId:'',
        advanced: false,
        defaultDate: moment(new Date(), 'YYYY-MM-DD'),
        // table
        columns: [
          {
            // title: '',
            slots: { title: 'title_materielName'},
            dataIndex: 'materielName',
            key: 'materielName',
            width: '150px',
            scopedSlots: { customRender: 'materielName' }
          },
           {
            // title: '预约数量',
            slots: { title: 'title_predictQuantity'},
            dataIndex: 'predictQuantity',
            key: 'predictQuantity',
            width: '160px',
            scopedSlots: { customRender: 'predictQuantity' }
          }, 
          {
            // title: '车牌号',
            slots: { title: 'title_vehicleNo'},
            dataIndex: 'vehicleNo',
            key: 'vehicleNo',
            width: '150px',
            scopedSlots: { customRender: 'vehicleNo' }
          },
          {
            // title: '司机姓名',
            slots: { title: 'title_driverName'},
            dataIndex: 'driverName',
            key: 'driverName',
            width: '210px',
            scopedSlots: { customRender: 'driverName' }
          },
          {
            // title: '手机号',
            slots: { title: 'title_phone'},
            dataIndex: 'phone',
            key: 'phone',
            width: '160px',
            scopedSlots: { customRender: 'phone' }
          },
          {
            // title: '上门日期',
            slots: { title: 'title_appointedDate'},
            dataIndex: 'appointedDate',
            key: 'appointedDate',
            width: '180px',
            scopedSlots: { customRender: 'appointedDate' }
          },
          {
            title: '身份证号',
            dataIndex: 'idcard',
            key: 'idcard',
            width: '150px',
            scopedSlots: { customRender: 'idcard' }
          },
          {
            title: '操作',
            key: 'action',
            //width: '13%',
            scopedSlots: { customRender: 'operation' }
          }
        ],
        data: [],
        errors: []
      }
    },

    created () {
      this.selectedBizId = this.bizList[0].id
      this.loadBaseInfoList()
      const roles = store.getters.roles
      this.roleId = this.$store.getters.roles
      // 如果登录的用户不是供应商,目前为管理员或采购员,需要选择供应商
      //if (this.roleId !== this.config.RoleType.SUPPLIER){
        this.loadSupplierSelect()
      //}
      this.loadBusinessList()
      this.handleBizChange(this.selectedBizId)
    },
  
    methods: {
      moment,

      getCurDate () {
        let date = formatDate(new Date(), 'yyyy-MM-dd')
        return date
      },
      loadSupplierSelect () { // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = getCorpSupplierList({ }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.supplierSelect = res
          if (this.supplierSelect && this.supplierSelect.length > 0){
            this.corpSupplierId =  this.supplierSelect[0].id
          }
        })
      },

      loadBusinessList () { // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = corpBusinessList({ }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.businessSelect = res
          if (this.businessSelect && this.businessSelect.length > 0){
            this.corpBusinessId =  this.businessSelect[0].id
          }
        })
      },

      handleBizChange(value) {
        this.data = []
        this.materList = this.materielData[value]
        this.selectMater =  {key: '', label: '请选择'}
        this.selectMaterielId = null
        this.selectMaterielName = null
   
        this.driverShowList = []
        this.vehicleShowList = []
        this.phoneShowList = []
        this.idcardShowList = []
        this.dateShowList = []
      },

      loadBaseInfoList () { // 从后台拉去下拉列表数据
        new Promise(resolve => {
          const data = baseInfoList({ }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.materielList = res.materielList
          this.driverList = res.driverList
          this.vehicleList = res.vehicleList
          this.vehicleNoList = res.vehicleNoList
          this.driverNameList = res.driverNameList
          this.phoneList = res.phoneList
       
          for (var i = 0; i < this.materielList.length; i++){
            let materie = this.materielList[i]
            if ( !(this.materielData[materie.businessTypeId] instanceof Array) ){
                this.materielData[materie.businessTypeId] = []
              }
              this.materielData[materie.businessTypeId].push(materie)
          }
          this.materList = this.materielData[this.selectedBizId]
        })
      },
      
      filterOption (input, option) { // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      clone () {
        const newData = [...this.data]
        if (!this.selectMaterielId || newData.length === 0) return
        let obj = null
        let length = newData.length
        let reverseData = newData.reverse()
        for (let i = 0;i < length; i++){
          let item = reverseData[i]
          if (this.selectMaterielId === item.materielId){
            obj = item
            break
          }
        }
        this.vehicleShowList[length] = obj.vehicleNo
        let driverName = obj.driverName.substring(0,obj.driverName.indexOf("("))
        this.driverShowList[length] = driverName
        this.phoneShowList[length] = obj.phone
        this.idcardShowList[length] = obj.idcard
        this.dateShowList[length] = obj.appointedDates

        this.newMember(obj)
  
      },

      newMember (obj) {
        if ( this.selectedBizId === this.config.BusinessTypeId.purchase && !this.corpSupplierId){
          this.$message.warning('请选择供应商',3)
          this.selectMater = {key: '', label: '请选择'}
          return;
        }
        if ( this.selectedBizId === this.config.BusinessTypeId.sell && !this.corpBusinessId){
          this.$message.warning('请选择客户',3)
          this.selectMater = {key: '', label: '请选择'}
          return;
        }

        const length = this.data.length
        if ( length > 0 && this.preBizId !== this.selectedBizId){
          this.$message.warning('只能预约同一种类型的物料',3)
          return
        }
        if (!this.selectMaterielName || !this.selectMaterielId){
            this.$message.warning('请选择物料',3)
            return;
        }
        // this.setDriverTitle()
        this.preBizId = this.selectedBizId
        this.data.push({
          key: length === 0 ? '1' : (parseInt(this.data[length - 1].key) + 1).toString(),
          materielName: this.selectMaterielName,
          materielId: this.selectMaterielId,
          predictQuantity: '',
          vehicleNo: obj && obj.vehicleNo || '',
          driverName: obj && obj.driverName || '',
          phone: obj && obj.phone || '',
          appointedDate: obj && obj.appointedDate || this.getCurDate(),
          appointedDates: obj && obj.appointedDates ||  moment(new Date(), 'YYYY-MM-DD'),
          idcard: obj && obj.idcard || '',
          // editable: true,
          // isNew: true
        })
        setTimeout(this.config.excuteSetTitle,1000);
      },
      remove (key) {
        const newData = this.data.filter(item => item.key !== key)
        this.data = newData
      },

      deCompletionDriverName(completedDriverName){
        let driverName = completedDriverName.substring(0, completedDriverName.indexOf("("));
        let phone = completedDriverName.substring(completedDriverName.indexOf("(")+1, completedDriverName.indexOf(")"));
        return {"driverName":driverName, "phone":phone};
      },

      handleChange (value, key, column) {
        const newData = [...this.data]
        const target = newData.filter(item => key === item.key)[0]
        if (target) {
          target[column] = value
          this.data = newData
        }
      },
      
      changeMateriel(e) {
        this.selectMaterielId = e.key
        this.selectMaterielName = e.label
        this.selectMater =  {key: e.key.toString(), label: e.label}
        this.newMember()
      },

      changeNumber(value, key) {
        value = parseFloat(value);
        if (!value || isNaN(value)){
          value = 0;
          // return;
        }
        const newData = [...this.data]
        const target = newData.filter(item => key === item.key)[0]
        if (target) {
          target['predictQuantity'] = value
          this.data = newData
        }
      },

      changeDriver(value, key, index, isDisableSuggestion) {
        const newData = [...this.data]
        const target = newData.filter(item => key === item.key)[0]
        if (target) {
          // 处理下司机姓名的显示
          // target['driverName'] = value.substring(0,value.indexOf("("))
          // this.driverShowList[index] = value;
          target['driverName'] = value
          if (value.indexOf("(") != -1){
            let driverName = value.substring(0,value.indexOf("("))
            this.driverShowList[index] = driverName

            let phone = value.substring(value.indexOf("(")+1, value.indexOf(")"));
            this.changePhone(phone, key, index)
        /*     if (!isDisableSuggestion){
              // this.querySuggetion(key,index, driverName)
              this.querySuggetion(key,index, value)
            } */
          }else{
            this.driverShowList[index] = value;
          }
        
          this.data = newData
        }
      },
      
      changeVehicleNo(value, key, index, isUpperCase) {
        const newData = [...this.data]
        const target = newData.filter(item => key === item.key)[0]
        if (target) {
          // 限制只能输入7位
          if (value.length > this.config.vehicleNoLength){
            value = value.substring(0,this.config.vehicleNoLength)
          } 
          value = noSpace(value)
          // 转换成大写
          // if (isUpperCase === true && value.length === 7){
          if (isUpperCase === true && value.length >= 7){
            value = value.toUpperCase();
          }
          // 处理下司机姓名的显示
          target['vehicleNo'] = value
          this.vehicleShowList[index] = value
          this.data = newData
        /*   if (!isDisableSuggestion && value.length === 7){
            this.querySuggetion(key, index, null, value, null)
          } */
        }
      },
  

      changeDV (e, key, col) {
        let selecId = e.key
        let selectName = e.label
        const newData = [...this.data]
        const target = newData.filter(item => key === item.key)[0]
        if (target) {
          if (col === "driverName"){
            target['driverName'] = selectName
            target['driverId'] = selecId
          }
          if (col === "vehicleNo"){
            target['vehicleNo'] = selectName
            target['vehicleId'] = selecId
          }
          this.data = newData
        }

      },
      changePhone(value, key, index, isDisableSuggestion) {
        const newData = [...this.data]
        const target = newData.filter(item => key === item.key)[0]
        if (target) {
          target['phone'] = value
          this.phoneShowList[index] = value
          this.data = newData
        /*   if (!isDisableSuggestion && this.config.Regex.telephone.test(value)){
            this.querySuggetion(key, index, null,null,value)
          } */
        }
      },

      changeIdcard(e, key, index) {
        let value = e.target.value
        if (value){
          value = value.toUpperCase();
        }
        const newData = [...this.data]
        const target = newData.filter(item => key === item.key)[0]
        if (target) {
          target['idcard'] = value
          this.idcardShowList[index] = value
          this.data = newData
        }
      },

      changeDate(dates, dateStrings, key, index) {
        const newData = [...this.data]
        const target = newData.filter(item => key === item.key)[0]
        if (target) {
          target['appointedDate'] = dateStrings
          target['appointedDates'] = dates
          /* let date = new Date(dateStrings.replace(/-/g, '/'))
          console.log(formatDate(new Date(date), 'yyyy-MM-dd'))
          this.dateShowList[index] = moment(new Date(dateStrings.replace(/-/g, '/')), 'YYYY-MM-DD'), */
          this.dateShowList[index] = dates
          this.data = newData
        }
      },

      check_car_name(car_name){
        var re=/^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z_0-9]{5}$/;
        if(car_name.search(re)==-1){
            return false;
        }else{
            return true;
        }
      }, 
      validate () {
         if (this.data.length === 0){
            this.$message.warning('请添加预约信息',3)
            return false
         }

         this.selectedBizId === this.config.BusinessTypeId.sell 
         if (this.selectedBizId === this.config.BusinessTypeId.purchase && !this.corpSupplierId){
            this.$message.warning('请选择供应商',3)
            return;
         }
         if (this.selectedBizId === this.config.BusinessTypeId.sell && !this.corpBusinessId){
            this.$message.warning('请选择客户',3)
            return;
         }
         for (let i=0; i<this.data.length; i++){
            let item = this.data[i]
            if (!item.materielName || /* item.predictQuantity ==="" || */ !item.driverName ||  !item.vehicleNo || !item.phone || !item.appointedDate){
              this.$message.warning('请完善预约信息',3)
              return false
            }
    /*         if ( parseFloat(item.predictQuantity) <= 0) {
              this.$message.warning('预约数量不能小于等于0',3)
              return false
            } */
/*             if (item.vehicleNo.length != 7){
              this.$message.warning('车牌号必须为七位数',3)
              return false;
            } */
        
     /*        if (this.check_car_name(value) == false) {
              this.$message.warning('请输入正确的车牌号',3)
              return false;
            } */
            if (!this.config.Regex.telephone.test(item.phone)) {
              this.$message.warning('手机号格式错误',3)
              return false
            }
          /* if (!this.config.Regex.idCardNum.test(item.idcard)) {
             this.$message.warning('身份证格式错误',3)
             return false
           }*/
            var today = new Date();
            var targetDate = new Date(item.appointedDate+" 23:59:59".replace("-", "/").replace("-", "/"));
            if (targetDate < today){
              this.$message.warning('上门日期不能小于当天',3)
              return false;
            }
            // 设置下供应商和业务类型ID
            item.businessTypeId = this.selectedBizId
            if (this.selectedBizId === this.config.BusinessTypeId.sell){
              item.corpBusinessId = this.corpBusinessId
              item.corpSupplierId = null
            }else{
              item.corpSupplierId = this.corpSupplierId
              item.corpBusinessId = null
            }
            if (this.selectedBizId == this.config.BusinessTypeId.waste || this.selectedBizId == this.config.BusinessTypeId.veer){
              if (!item.operType){
                this.$message.warning('操作类型不能为空',3)
                return false;
              }
              if (!item.weighType){
                this.$message.warning('过磅类型不能为空',3)
                return false;
              }
            }
         }
         return true
      },

      // 最终全页面提交
      doSubmit () {
        if (!this.validate()){
          return
        }
        const _this = this
        _this.confirmLoading = true
        Bus.$emit('showSpinning', true, "提交中...")
        reservationAdd(JSON.stringify(this.data))
        .then(res => {
          if (res.code === '0') {
            _this.$message.success('提交成功')
            this.data = []
            this.driverShowList = []
            this.vehicleShowList = []
            this.phoneShowList = []
            this.$router.push({ name: 'reservation' })
          }
        }).catch(() => {
        }).finally(() => {
          _this.confirmLoading = false
          Bus.$emit('showSpinning', false)
        })
      },
      scrollToField (fieldKey) {
        const labelNode = document.querySelector(`label[for="${fieldKey}"]`)
        if (labelNode) {
          labelNode.scrollIntoView(true)
        }
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
    .card{
      margin-bottom: 1px;
    }
 
  </style>
  